import type { SurveyDefaultAssetsProp } from "./survey.types";
import { ReactComponent as SurveyImage1 } from "../../ui/assets/survey_1.svg";
import { ReactComponent as SurveyImage2 } from "../../ui/assets/survey_2.svg";
import { ReactComponent as SurveyImage3 } from "../../ui/assets/survey_3.svg";

export const SURVEYS_ANSWERS_LOCAL_STORAGE_KEY = "surveysAnswers";

export const SURVEY_DEFAULT_PROPS: SurveyDefaultAssetsProp[] = [
  { color: "primary", logo: <SurveyImage1 /> },
  { color: "secondary", logo: <SurveyImage2 /> },
  { color: "tertiary", logo: <SurveyImage3 /> },
];

export const SURVEY_COLOR_MAP: Record<
  number,
  { bgColor: string; textColor: string }
> = {
  1: { bgColor: "#FED134", textColor: "#383B48" },
  2: { bgColor: "#6B23C9", textColor: "#FFFFFF" },
  3: { bgColor: "#00B44F", textColor: "#FFFFFF" },
};
